

const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'jfif', 'bmp', 'avif'];
const IsImage = (name: string) => {
    const extension = GetExtension(name);
    return imageExtensions.includes(extension ?? '');
}


const videoExtensions = ['mp4', 'webm', 'mkv', 'mov', 'avi'];
const IsVideo = (name: string) => {
    const extension = GetExtension(name);
    return videoExtensions.includes(extension ?? '');
}


const audioExtensions = ['mp3', 'wav', 'flac', 'm4a', 'ogg', 'wma'];
const IsAudio = (name: string) => {
    const extension = GetExtension(name);
    return audioExtensions.includes(extension ?? '');
}


const documentExtensions = ['pdf', 'csv', 'xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx', 'txt'];
const IsDocument = (name: string) => {
    const extension = GetExtension(name);
    return documentExtensions.includes(extension ?? '');
}


const GetExtension = (name: string) => {
    return name.split('.').pop()?.split('?')[0] ?? '';
}


const CreateUrl = (file: File) => {
    return URL.createObjectURL(file);
}



const FileHelper = {
    IsImage,
    IsVideo,
    IsAudio,
    IsDocument,
    GetExtension,
    CreateUrl
}

export default FileHelper;


export {
    imageExtensions,
    videoExtensions,
    audioExtensions,
    documentExtensions
};